export const SET_CERTIFICADO = (state, hasCertificado) => {
    state.hasCertificado = hasCertificado;
};
